import React from "react";
import { AppContextProvider, CartContextProvider, PageConfigurationContextProvider } from "@catchoftheday/common-vendors";
import { CustomerContextProvider } from "@catchoftheday/customer";
import { OnePassConfigurationContextProvider, OnePassHeroDealsContextProvider } from "@catchoftheday/onepass";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var Page = function Page(_ref) {
  var children = _ref.children;
  return ___EmotionJSX(AppContextProvider, {
    contexts: [OnePassConfigurationContextProvider, PageConfigurationContextProvider, CustomerContextProvider, OnePassHeroDealsContextProvider, CartContextProvider]
  }, children);
};
export default Page;